import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { SystemLogComponent } from './system-log.component';
import { SystemLogService } from '../core/service/system-log.service';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    SystemLogComponent
  ],
  exports: [
    SystemLogComponent
  ],
  providers: [
    SystemLogService
  ]
})
export class SystemLogModule { }
